import { render } from "./PickingAssignment.vue?vue&type=template&id=239fa1dc&scoped=true"
import script from "./PickingAssignment.vue?vue&type=script&lang=js"
export * from "./PickingAssignment.vue?vue&type=script&lang=js"

import "./PickingAssignment.vue?vue&type=style&index=0&id=239fa1dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239fa1dc"]])

export default __exports__